import React from "react";
import InputField from "../input/inputField";

interface Props {
  className: string;
  setClassName: (blockName: string) => unknown;
}

export const ClassForm = ({ className, setClassName }: Props) => {
  return (
    <div className="flex flex-col">
      <InputField
        value={className}
        setValue={setClassName}
        label="Class name"
        placeHolder="Enter class name"
      />
    </div>
  );
};
